import { extractErrorDetails } from "./errorUtils.js";
import { classifyNodeError } from "./nodeErrorClassifier.js";
export class BalanceProvider {
    constructor() {
        // Not reported here: BalanceResolver reports one error per fetch listing every
        // failed token, instead of one report per token.
        this.resolveTokenBalanceFetchError = (err, token, network, isNativeCurrency) => {
            const errorDetails = extractErrorDetails(err);
            const category = classifyNodeError(err);
            const tokenBalance = {
                network: network.name,
                token: token.symbol,
                amount: undefined,
                request_time: new Date().toJSON(),
                decimals: Number(token?.decimals),
                isNativeCurrency: isNativeCurrency ?? !token.contract,
                error: {
                    message: errorDetails.message,
                    name: errorDetails.name,
                    stack: errorDetails.stack,
                    code: errorDetails.code,
                    status: errorDetails.status,
                    statusText: errorDetails.statusText,
                    responseData: errorDetails.responseData,
                    requestUrl: errorDetails.requestUrl,
                    category: category
                }
            };
            return tokenBalance;
        };
    }
}
